/**
 * i18next setup — 4 limbi bundle-uite inline (fără lazy-load), fallback RO.
 * Detectare prin localStorage (key `cerbes-lang`) + navigator.language.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@/locales/en/common.json';
import ro from '@/locales/ro/common.json';
import fr from '@/locales/fr/common.json';
import de from '@/locales/de/common.json';

export const LANGUAGES = [
  { code: 'ro', label: 'Română' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const LANG_STORAGE_KEY = 'cerbes-lang';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      ro: { common: ro },
      fr: { common: fr },
      de: { common: de },
    },
    defaultNS: 'common',
    fallbackLng: 'ro',
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

// `<html lang>` urmează limba aleasă (cititoare de ecran, despărțire în silabe,
// corector ortografic) — în index.html e doar valoarea de pornire.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng.split('-')[0];
};
syncHtmlLang(i18n.resolvedLanguage || i18n.language || 'ro');
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
